import { ValidationError } from 'common/interfaces/common';

export const getAccessByPropPath = (object: unknown, path: string): ValidationError =>
  path
    .replaceAll(/\[|]\.*/g, res => (res === ']' ? '' : '.'))
    .split('.')
    .reduce((obj, prop) => obj && obj[prop], object) as ValidationError;
